"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTriggerButton = void 0;
var _TriggerButton = require("./TriggerButton");
// TODO: in v9, move styled() from TriggerButton.jsx to here
var StyledTriggerButton = _TriggerButton.TriggerButton;
exports.StyledTriggerButton = StyledTriggerButton;